import Content from "@/views/MGT/Version/Components/Content";
import { versionInfo } from "@/service/version";
export default {
  name: "VersionNoPage",
  components: {
    Content
  },
  data() {
    return {
      pageSize: 10,
      list: [],
      showNext: true
    };
  },
  methods: {
    onChangeNextpage() {
      this.pageSize += 10;
      this.getVersion();
    },
    setShowNext(totalRows) {
      if (totalRows === this.list.length) {
        this.showNext = false;
      }
    },
    async getVersion() {
      const params = {
        firstResult: 0,
        pageSize: this.pageSize
      };
      let res = await versionInfo(params);
      if (res.data && res.data.result === 0) {
        this.list = res.data.retVal.datas;
        this.setShowNext(res.data.retVal.totalRows);
      }
    }
  },
  mounted() {
    this.getVersion();
  }
};